import { z } from 'zod';

export const getMWApplicationsSchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    code: z.number(),
    name: z.string(),
    worksOffline: z.boolean(),
    deleted: z.boolean(),
  })
);

export type GetMWApplications = z.infer<typeof getMWApplicationsSchema>;
